export interface Category {
  name: string;
  slug: string;
  description: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    name: "网红塌房",
    slug: "wanghong-tafang",
    description: "追踪网红主播、短视频创作者等网络红人的人设崩塌事件，揭露虚假人设背后的真相。涵盖直播间翻车、虚假宣传、粉丝纠纷等内容，最快最全的网红塌房现场直击。",
    articleCount: 326,
  },
  {
    name: "明星爆料",
    slug: "mingxing-baoliao",
    description: "深度挖掘娱乐圈明星艺人的最新爆料与黑料，包括感情纠葛、合约纠纷、行业潜规则等。从顶流到新生代，不放过任何一条有价值的明星八卦资讯。",
    articleCount: 512,
  },
  {
    name: "每日吃瓜",
    slug: "meiri-chigua",
    description: "每日更新的最新吃瓜资讯汇总，涵盖网红圈、娱乐圈、电竞圈等多领域热点事件。让你不错过任何一条热门八卦，每天都有新鲜瓜可吃。",
    articleCount: 847,
  },
  {
    name: "精选内容",
    slug: "jingxuan-neirong",
    description: "编辑团队精心挑选的深度内容和行业观察，包括热点事件深度分析、行业乱象调查、人物特写等。不仅吃瓜，更懂瓜背后的故事。",
    articleCount: 158,
  },
];

export const getCategoryBySlug = (slug: string): Category | undefined => {
  return categories.find((category) => category.slug === slug);
};